module.exports = __webpack_public_path__ + "static/media/warmup1.5d7c709c.png";